import { styled } from '@linaria/react';
import { bodyFont, colors, fonts, layout, space } from '../../theme/tokens';

export const GuestRow = styled.button<{ $selected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: ${space[3]} ${space[4]};
  margin-bottom: ${space[2]};
  border: 2px solid ${({ $selected }) => ($selected ? colors.fontPrimary : colors.borderGrey)};
  border-radius: ${layout.borderRadiusMd};
  background: ${colors.white};
  cursor: pointer;
  transition: border-color 0.15s ease;

  &:hover {
    border-color: ${colors.fontPrimary};
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const GuestInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${space[1]};
`;

export const GuestName = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.semiBold};
  color: ${colors.fontPrimary};
`;

export const GuestPrice = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.xs};
  color: ${colors.fontSecondary};
`;

export const Indicator = styled.span<{ $selected: boolean }>`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 2px solid ${({ $selected }) => ($selected ? colors.fontPrimary : colors.borderGrey)};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: border-color 0.15s ease, background 0.15s ease;
  background: ${({ $selected }) => ($selected ? colors.fontPrimary : 'transparent')};

  &::after {
    content: '';
    display: ${({ $selected }) => ($selected ? 'block' : 'none')};
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${colors.white};
  }
`;

export const GuestList = styled.div`
  padding-bottom: ${space[4]};
`;

export const FooterContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${space[4]} ${space[5]};
  gap: ${space[4]};
`;

export const FooterLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[1]};
`;

export const FooterTitle = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.semiBold};
  color: ${colors.fontPrimary};
`;

export const FooterTotal = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.bold};
  color: ${colors.fontPrimary};
`;
